
import '@/core/setup/env';
import '@/core/setup/vue';
import '@/core/setup/prism';
import Vue from 'vue';
import App from './App.vue';
import router from '@/core/routes';
import store from '@/core/store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render (h) {
    return h(App, []);
  },
}).$mount('#app');
